// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"ac843f89","324":"481d61ee","850":"4b49dad9"}[chunkId] + ".chunk.css";
};